import React from 'react';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Modal from '@common/components/Modal';
import userPersonas from '@common/constants/userPersonas';
import ZillowPlusStripeImage from '@assets/zillow_plus_stripe.svg';
import SpinnerContainer from '@common/components/SpinnerContainer';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import './index.scss';
import { logError } from '@zg-rentals/log-error';

type Props = {
  onNext: () => void;
  onClose: () => void;
  showModalNotification: (string) => void;
};

const StripeVerificationPage: React.FC<React.PropsWithChildren<Props>> = (props: Props): JSX.Element => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const onNext = (): void => {
    Promise.resolve()
      .then(() => setIsLoading(true))
      .then(() => props.onNext())
      .then(() => setIsLoading(false))
      .catch((error) => {
        logError({ error, context: 'StripeVerificationPage - onNext' });
        setIsLoading(false);
        props.showModalNotification(DEFAULT_ERROR);
      });
  };

  const onClose = (): void => {
    props.onClose();
  };

  return (
    <Modal persona={userPersonas.LANDLORD} onRequestClose={onClose} dataAutoTestId="landlord-stripe-verification">
      {isLoading && <SpinnerContainer />}
      <Container>
        <Row>
          <Center>
            <img src={ZillowPlusStripeImage as unknown as string} alt="" className="zillowStripeImg" />
          </Center>
        </Row>
        <Row>
          <Center>
            <h3>Get Verified</h3>
          </Center>
        </Row>
        <Row>
          <Center>
            <Text>
              Our payment partner, Stripe, will verify your information so you can receive payments. Your information is
              secure and will be used for verification only.
            </Text>
          </Center>
        </Row>
        <Row>
          <Center>
            <Button type="primary" onClick={onNext}>
              Add Verification Info
            </Button>
          </Center>
        </Row>
      </Container>
    </Modal>
  );
};
export default StripeVerificationPage;
